import parseCSSColor from "parse-css-color";

export const shouldShowShadow = (color: string) => {
  const rgb = parseCSSColor(color || "");

  const [r, g, b] = rgb?.values || [0, 0, 0];

  return (r + g + b) / 3 > 180;
};
